// navigate-pagination.js - Complete solution for pagination history navigation

// State tracking
let paginationStateInitialized = false;

// Initialize as soon as the DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded - initializing pagination');
  setupInitialPaginationState();
  attachPaginationHandler();
});

// Set up initial pagination state and history overrides
function setupInitialPaginationState() {
  if (paginationStateInitialized) return;
  
  const pagination = document.querySelector('page-pagination');
  if (!pagination) {
    return;
  }
  
  // Set initial state with the current page
  const initialPage = new URL(location.href).searchParams.get('page') || '1';
  history.replaceState({ page: initialPage, managed: true }, '', location.href);
  
  // Add global popstate handler with high priority
  window.removeEventListener('popstate', handlePopState);
  window.addEventListener('popstate', handlePopState);
  
  paginationStateInitialized = true;
}

// Attach pagination click handler
function attachPaginationHandler() {
  const pagination = document.querySelector('page-pagination');
  if (!pagination) {
    return;
  }
  
  pagination.removeEventListener('pagination:page-changed', onForwardNavigation);
  pagination.addEventListener('pagination:page-changed', onForwardNavigation);
}

// Called when user clicks pagination links (forward navigation)
function onForwardNavigation(event) {
  
  const url = new URL(event.detail.url);
  const pageNumber = url.searchParams.get('page') || '1';
  
  // Push new state to history
  history.pushState({ page: pageNumber, managed: true }, '', url.href);
}

// Handle browser back/forward button (popstate)
function handlePopState(event) {
  
  // Always prevent default navigation to avoid page reload
  event.preventDefault && event.preventDefault();
  event.stopImmediatePropagation();
  
  // Get page from URL regardless of state object
  const currentUrl = window.location.href;
  const currentPage = new URL(currentUrl).searchParams.get('page') || '1';
  
  
  // Force our own navigation instead of browser's default behavior
  const $paginationLink = document.querySelector(`.pagination__nav a[data-page="${currentPage}"]`);
  
  if ($paginationLink) {
    // Stop any pending navigation
    window.stop && window.stop();
    
    // Click the link after a short delay
    setTimeout(() => {
      $paginationLink.click();
    }, 10);
    
    return false;
  } else {
    console.warn('No pagination link found for page', currentPage);
  }
}

// Make functions available globally
window.setupInitialPaginationState = setupInitialPaginationState;
window.attachPaginationHandler = attachPaginationHandler;